import { Field, ID, ObjectType } from 'type-graphql'
import { JobStateEnum } from '../queue/JobStateEnum'

@ObjectType()
export class QueueJobCompletedEvent {
  @Field(() => ID)
  jobId: string

  @Field(() => String)
  featureKey: string

  @Field(() => JobStateEnum)
  status: JobStateEnum

  @Field(() => String, { nullable: true })
  message?: string

  @Field(() => String, { nullable: true })
  resultPayload?: string
}
